import { formatTimestamp } from '@/util/helpers/time-helpers';

class ViewMeta {
  constructor(
    viewSeries,
    isSheetsShareable,
    isOtherShareable,
    emailDestinations,
    slackDestinations,
    zapierCount,
    dashboardIds,
    noOfSteps,
    isSql,
    errorMsg,
    noOfRows,
    lastRefreshed,
    bucketFeeds,
  ) {
    this._viewSeries = viewSeries;
    this._isSheetsShareable = isSheetsShareable;
    this._isOtherShareable = isOtherShareable;
    this._emailDestinations = emailDestinations;
    this._slackDestinations = slackDestinations;
    this._zapierCount = zapierCount;
    this._dashboardIds = dashboardIds;
    this._noOfSteps = noOfSteps;
    this._isSql = isSql;
    this._errorMsg = errorMsg;
    this._noOfRows = noOfRows;
    this._lastRefreshed = lastRefreshed;
    this._bucketFeeds = bucketFeeds;
  }

  static buildFromServer(m) {
    return new ViewMeta(
      m._series,
      m._isSheetsShareable,
      m._isOtherShareable,
      m._emailDestinations,
      m._slackDestinations,
      m._zapierCount,
      m._dashboardIds,
      m._noOfSteps,
      m._isSql,
      m._errorMsg,
      m._noOfRows,
      formatTimestamp(m._last_refreshed_at),
      m._bucketFeeds,
    );
  }

  viewSeries() {
    return this._viewSeries;
  }

  isSheetsShareable() {
    return this._isSheetsShareable;
  }

  isOtherShareable() {
    return this._isOtherShareable;
  }

  emailDestinations() {
    return this._emailDestinations;
  }

  slackDestinations() {
    return this._slackDestinations;
  }

  zapierCount() {
    return this._zapierCount;
  }

  dashboardIds() {
    return this._dashboardIds;
  }

  noOfSteps() {
    return this._noOfSteps;
  }

  isSql() {
    return this._isSql;
  }

  errorMsg() {
    return this._errorMsg;
  }

  noOfRows() {
    return this._noOfRows;
  }

  lastRefreshed() {
    return this._lastRefreshed;
  }

  bucketFeeds() {
    return this._bucketFeeds;
  }
}

export default ViewMeta;
